﻿import { useEffect, useState } from 'react';

// lib 
import IconHelper from '@bazooka_se/lf-icons';
import { motion, AnimatePresence } from 'framer-motion';


const Answer = ({ ...props }) => {

    const [answer, setAnswer] = useState('')

    useEffect(() => {
        if (props.answer === "True") {
            setAnswer("Jag förstår")
        } else {
            const a = props.answer
            setAnswer(a)
        }
    }, [props.answer])

        
    return (
        <AnimatePresence>
            <motion.div
                className="pension-wizard-block__answer"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <span className="pension-wizard-block__answer__checkmark"
                    dangerouslySetInnerHTML={{ __html: IconHelper('check-circle').outerHTML }}>
                </span>
                <p className="pension-wizard-block__answer__text">{answer}</p>
            </motion.div>
        </AnimatePresence>
     )
}

export default Answer;

